import { internalCompaniesTypes } from '../types'

const initialState = {
  items: [],
  isRequesting: false,
  isRequestingCreatingEmployee: false,
  isRequestingDeletingEmployee: false,
  isError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case internalCompaniesTypes.GET_COMPANIES__REQUEST: return {
      ...state,
      isRequesting: true
    }
    case internalCompaniesTypes.GET_COMPANIES__SUCCESS: return {
      ...state,
      isRequesting: false,
      items: action.payload.items
    }
    case internalCompaniesTypes.CREATE_EMPLOYEE__REQUEST: return {
      ...state,
      isRequestingCreatingEmployee: true
    }
    case internalCompaniesTypes.CREATE_EMPLOYEE__FAILURE:
    case internalCompaniesTypes.CREATE_EMPLOYEE__SUCCESS: return {
      ...state,
      isRequestingCreatingEmployee: false,
    }
    case internalCompaniesTypes.DELETE_EMPLOYEE__REQUEST: return {
      ...state,
      isRequestingDeletingEmployee: true
    }
    case internalCompaniesTypes.DELETE_EMPLOYEE__FAILURE:
    case internalCompaniesTypes.DELETE_EMPLOYEE__SUCCESS: return {
      ...state,
      isRequestingDeletingEmployee: false
    }
    default:
      return state
  }
}
